/* eslint-disable prefer-destructuring */
export const ENV = process.env.ENV;
export const VERSION = process.env.VERSION;
export const LOCAL = process.env.LOCAL === 'TRUE';
